import React, { useEffect } from 'react'
import BackButton from 'src/components/backButton'

import _ from 'lodash'
import cx from 'classnames'
import styles from './styles.module.scss'
import IntegrationCard, { IntegrationStatus, NotifyAction, ToggleStatus } from '../../components/integrationCard'
import { SearchBar } from 'src/components/input'
import IntegrationsOptionsDropdown from '../../components/dropdown'
import { useCapabilitiesFetch, useCapabilitiesUpdate } from 'src/query/settings/dashboard'
import { IntegrationCapability, IntegrationCapabilityList } from 'src/types/settings/dashboard'
import { AllDone, NotifyActionSlider } from '..'
import { useNotifyUser } from 'src/query/settings/users'
import Slider from 'src/components/slider'
import Button from 'src/components/button'
import { calculatePercentage } from 'src/utils/util'
import withErrorBoundary from 'src/components/errorBoundary/withErrorBoundary'
import { useDashboardAdoption } from 'src/query/settings/adoption/dashboard'
import SwitchButton from 'src/components/switchButton'
import { toast } from 'react-toastify'
import Toast from 'src/components/toast'

const EmptyMessage = '/images/kiteErrorMessage.svg'
const SelectedIntegrationsEmptyImage = '/images/screwDriver.svg'

interface TechStackProps {
  setTechStackView: (view: boolean) => void;
}

function TechStack({ setTechStackView }: TechStackProps) {

  const { trackTechStackAdded, trackNotifyUsersClicked } = useDashboardAdoption();
  const { mutate: notifyUserMutate, isPending: isNotifyUserPending, isSuccess: isNotifyUserSuccess, isError: isNotifyUserError } = useNotifyUser();
  const { data: capabilities, isLoading: isLoadingCapabilities } = useCapabilitiesFetch(); 
  const { mutate: updateCapabilities, isSuccess: isEnableSucceed, isError: isEnableFailed, isPending: isEnabling } = useCapabilitiesUpdate();

  const [selectedOption, setSelectedOption] = React.useState<
    { value: string; label: string } | null
  >({ value: "all", label: "All Integrations" });
  const [integrations, setIntegrations] = React.useState<IntegrationCapabilityList>([]);
  const [notifyUser, setNotifyUser] = React.useState(false);
  const [selectedCapability, setSelectedCapability] = React.useState<IntegrationCapability | null>(null);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [enableTechStack, setEnableTechStack] = React.useState<IntegrationCapability | null>(null);
  const [disableTechStack, setDisableTechStack] = React.useState<IntegrationCapability | null>(null);

  useEffect(() => {
    let filteredCapabilities = capabilities || [];

    if(_.size(filteredCapabilities) > 0){
      // Filter by selected option/category
      if (selectedOption?.value !== "all") {
        filteredCapabilities = _.filter(filteredCapabilities,
          capability => capability.productCapabilityResponse.category.id === selectedOption?.value
        );
      }

      // Filter by search query
      if (searchQuery) {
        filteredCapabilities = _.filter(filteredCapabilities,
          capability =>
            _.includes(_.toLower(capability.productCapabilityResponse.name), _.toLower(searchQuery))
        );
      }
    }
    setIntegrations(filteredCapabilities);
  }, [selectedOption, searchQuery, capabilities]);

  useEffect(() => {
    if (isEnableSucceed || isEnableFailed) {
      if(isEnableSucceed && enableTechStack) {
        trackTechStackAdded(_.get(enableTechStack,"productCapabilityResponse.name", ""))
      }
      setEnableTechStack(null);
      setDisableTechStack(null);
    }
  }, [isEnableSucceed, isEnableFailed]);

  useEffect(() => {
    if (isNotifyUserSuccess || isNotifyUserError) {
      if (isNotifyUserSuccess) {
        trackNotifyUsersClicked();
        toast(<Toast.Sucess message={`Successfully notified users`} />, {
          autoClose: 3000,
        });
      }
      setNotifyUser(false);
    }
  }, [isNotifyUserSuccess, isNotifyUserError]);

  const handleToggleIntegration = (capability: IntegrationCapability) => {
    const enabled = capability.enabled;
    if (enabled) {
      setDisableTechStack(capability);
    } else {
      setEnableTechStack(capability);
    }

  };

  const handleNotifyUser = (id: string) => {
    setNotifyUser(true);
    setSelectedCapability(capabilities.find(capability => capability.id === id) || null);
  };
  const handleConfirmEnable = () => {
    if (!enableTechStack) return;
    toggleCapability(enableTechStack);
  };

  const handleConfirmDisable = () => {
    if (!disableTechStack) return;
    toggleCapability(disableTechStack);
  };

  const toggleCapability = (capability: IntegrationCapability) => {
    const updatedCapabilities = integrations?.map((item) =>
      item.id === capability.id ? { ...item, enabled: !item.enabled } : item
    );

    const body = updatedCapabilities?.map(({ id, enabled }) => ({ id, enabled }));

    updateCapabilities({ capabilities: body });
  };

  if (isLoadingCapabilities) {
    return <div className={styles.loading}>Loading...</div>;
  }

  const enabledCapabilities = capabilities?.filter(
    (capability) => capability.enabled
  );

  return (
    <div className={styles.techStack}>
      <div className={styles.left}>

        <BackButton
          className={cx(styles.backButton, styles.alignCenter)}
          title={"manage tech stack"}
          onClick={() => {
            setTechStackView(false)
          }}
        />

        <div className={styles.selectedIntegrationsContainer}>
          <div className={styles.selectedIntegration}>
            <p className={styles.title}>selected integrations</p>

            <div className={styles.integrationCards}>
              {_.size(enabledCapabilities) > 0 && enabledCapabilities.map((capability: IntegrationCapability) => {
                return (
                  <IntegrationCard
                    key={capability.id}
                    title={capability.productCapabilityResponse.name}
                    subTitle={ capability.percentage === 100 ? "Integration done by all team members" : `${capability.totalUsers - capability.count} of ${capability.totalUsers} team members need to set up`}
                    className={styles.integrationCard}
                    type="notify"
                    actionType={
                      capability.percentage === 100 ? <AllDone/>:
                      <NotifyAction
                        percentage={capability.percentage}
                        showNotifyButton={capability.percentage !== 100}
                        handleNotifyUser={() => handleNotifyUser(capability.id)}
                      />
                    }
                    iconUrl={capability.productCapabilityResponse.icon}
                  />
                );
              })}

              {_.size(enabledCapabilities) === 0 && (
                <div className={cx(styles.emptyMessage)}>
                  <div>
                    <img src={SelectedIntegrationsEmptyImage} alt="No Integrations" />
                    <p className={styles.noIntegrationsText}>No integrations selected</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.marketPlace}>
        <div className={styles.header}>
          <div className={styles.title}>marketplace</div>
          <div className={styles.subTitle}>Configure and enable integrations to power your team’s tech stack.</div>
        </div>

        <div className={styles.searchContainer}>
            <div className={styles.searchBar}>
               <SearchBar query={searchQuery} onSearch={(query) => setSearchQuery(query ? query : "")} />
            </div>
          <IntegrationsOptionsDropdown
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        </div>

        <div className={styles.integrationsContainer}>
          {_.size(integrations) > 0 && integrations.map((capability: IntegrationCapability) => {
            return (
              <IntegrationCard
                key={capability.id}
                className={styles.capabilityCard}
                title={capability.productCapabilityResponse.name}
                subTitle={capability.productCapabilityResponse.description}
                type="capability"
                actionType={
                  <SwitchButton
                    id={capability.id}
                    checked={capability.enabled}
                    handleCheck={() => handleToggleIntegration(capability)}
                    className={styles.toggleButton}
                  />
                }
                iconUrl={capability.productCapabilityResponse.icon}
              />
            );
          })}

          {_.size(integrations) === 0 && (
            <div className={cx(styles.emptyMessage)}>
              <div>
                <img src={EmptyMessage} alt="No Integrations" />
                <p className={styles.noIntegrationsText}>No integrations found</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Slider.Dialog
        width="300"
        show={enableTechStack ? true : false}
        onClose={() => setEnableTechStack(null)}
      >
        <Slider.Header
          title="activating"
          message={enableTechStack?.productCapabilityResponse?.name} />
        <Slider.Body>
          <p className={styles.enableStack}>
            <img src={enableTechStack?.productCapabilityResponse?.icon} />
            <p className={styles.name}>{enableTechStack?.productCapabilityResponse?.name}</p>
            <p className={styles.description}>{enableTechStack?.productCapabilityResponse?.description}</p>
          </p>
        </Slider.Body>

        <Slider.Actions>
          <Button variant="primary" icon='paperflite-tick' text={isEnabling ? "Enabling..." : "Confirm"} disabled={isEnabling} onClick={handleConfirmEnable}></Button>
          <Button variant="secondary" text="Cancel" disabled={isEnabling} onClick={() => setEnableTechStack(null)}></Button>
        </Slider.Actions>
      </Slider.Dialog>


      <Slider.Dialog
        width="300"
        show={disableTechStack ? true : false}
        onClose={() => setDisableTechStack(null)}
      >
        <Slider.Header
          title="deactivating"
          message={disableTechStack?.productCapabilityResponse?.name} />
        <Slider.Body>
          <p className={styles.disableStack}>
            <p className={styles.message}>This will hide {disableTechStack?.productCapabilityResponse?.name} as an option for new team members.</p>
            <p className={styles.message}>Current users remain connected. Multiple integrations are supported, except email, which allows only one at a time.</p>

            {disableTechStack && <IntegrationCard
              key={disableTechStack.id}
              className={styles.capabilityCard}
              title={disableTechStack.productCapabilityResponse.name}
              subTitle={disableTechStack.productCapabilityResponse.description}
              type="capability"
              actionType={
                disableTechStack.percentage === 100 ? <AllDone /> :
                <NotifyAction
                  percentage={disableTechStack?.percentage}
                />
              }
              iconUrl={disableTechStack.productCapabilityResponse.icon}
            />}

          </p>
        </Slider.Body>

        <Slider.Actions>
          <Button variant="primary" icon='paperflite-tick' text={isEnabling ? "Disabling..." : "Confirm"} disabled={isEnabling} onClick={handleConfirmDisable}></Button>
          <Button variant="secondary" text="Cancel" disabled={isEnabling} onClick={() => setDisableTechStack(null)}></Button>
        </Slider.Actions>
      </Slider.Dialog>

      <NotifyActionSlider
        show={notifyUser}
        onClose={() => setNotifyUser(false)}
        isNotifyUserPending={isNotifyUserPending}
        handleNotifyUserClick={(id) => notifyUserMutate(id)}
        capability={selectedCapability}
      />
    </div>
  )
}

export default withErrorBoundary(TechStack); 
